import _ from "lodash";
import Indicador from "..";
import ADFEditFields from "./components/ADFEditFields";
import { ADFParamFields } from "./components/ADFParamFields";
import adfReport from "./reports";
import adfReportSummary from "./reports/summary";

export default class ADF extends Indicador {
    static get fullName() {
        return "Aferição da Dosagem de Fertilizantes";
    }

    static get abbrev() {
        return "ADF";
    }

    static get multTipo() {
        return true
    }

    static get legacyApontamentoMap() {
        return {
            dataHoraDF: {
                newField: "date",
                convert: this.parseLegacyDate,
            },

            tipo: "tipo",
            talhao: "talhao",
            trator: "trator",
            seletorImplementoDF: "implemento",
            frente: "frente",
            turno: "turno",

            seletorInsumoDF: "insumo",
            dosagemRecomendadaDF: "dosagemRecomendada",

            coletasDF: {
                type: Array,
                newField: "coletas",
                children: {
                    pesagemDF: "pesagem",
                    observacaoColetaDF: "observacao",
                    foto: {
                        newField: "image.uid",
                        convert: this.convertLegacyImageUid,
                    },
                    confirmaRelatorio: "confirmaRelatorio",
                    "foto.georeferencia": "georeferencia",
                    georeferencia: "georeferencia",
                },
            },

            conformidadeAmostra: "conformidade",
            afericaoDF: "afericao",
            mediaColetasDF: "media",
            dosePorMetroDF: "doseMetroLinear",

            observacaoAmostraDF: "observacao",

            itensColetaDF: "images",
        };
    }

    static get legacyParamMap() {
        return {
            intervaloAderenciaMinimoManual: "manual.intervaloMin",
            intervaloAderenciaMaximoManual: "manual.intervaloMax",
            metrosLinearesAmostraManual: "manual.metrosLinearesAmostra",
            metrosLinearesHectareManual: "manual.metrosLinearesHectare",
            metaDFManual: "manual.meta",

            intervaloAderenciaMinimoMecanizado: "mecanizado.intervaloMin",
            intervaloAderenciaMaximoMecanizado: "mecanizado.intervaloMax",
            metrosLinearesAmostraMecanizado: "mecanizado.metrosLinearesAmostra",
            metrosLinearesHectareMecanizado: "mecanizado.metrosLinearesHectare",
            metaDFMecanizado: "mecanizado.meta",
        };
    }

    static paramFields(tipoIndicadorField = '') {
        return <ADFParamFields tipoIndicadorField={tipoIndicadorField} />
    }

    static getEditFields(visita, isNew, TipoClass) {
        return <ADFEditFields visita={visita} TipoClass={TipoClass} />
    }

    async renderReport(visita) {
        return adfReport(this, visita);
    }

    async renderReportSummary(visita, tipoName) {
        return adfReportSummary(this, visita, tipoName);
    }

    static calcConformidade(apontamento, params) {
        const f = parseFloat;

        if (!apontamento.coletas || !params || apontamento.coletas.length === 0) {
            return 0;
        }

        const total = apontamento.coletas.length;
        let sumPesagem = 0;

        for (const coleta of apontamento.coletas) {
            if (coleta.pesagem) {
                sumPesagem += f(coleta.pesagem);
            }
        }

        apontamento.media = sumPesagem / total;
        apontamento.media = apontamento.media.toFixed(4);

        // Dose por metro linear média das coletas.
        apontamento.doseMetroLinear = apontamento.media / f(params.metrosLinearesAmostra);
        apontamento.doseMetroLinear = apontamento.doseMetroLinear.toFixed(4);

        apontamento.afericao = apontamento.doseMetroLinear * f(params.metrosLinearesHectare);
        apontamento.afericao = apontamento.afericao.toFixed(4);

        const dosagemRecomendada = f(apontamento.dosagemRecomendada);

        if (!_.isNaN(dosagemRecomendada)) {
            const rawConformidade = (apontamento.afericao / f(apontamento.dosagemRecomendada)) * 100;
            apontamento.acima = rawConformidade > f(params.intervaloMax) ? 1 : 0;
            apontamento.abaixo = rawConformidade < f(params.intervaloMin) ? 1 : 0;
            let conformidade = rawConformidade > 100 ? rawConformidade - 200 : rawConformidade;

            return Math.abs(conformidade).toFixed(2);
        } else {
            apontamento.acima = 0;
            apontamento.abaixo = 0;
            return 0;
        }
    }

    static getConformidadeStatus(conformidade, meta) {
        return this.calcConformidadeStatus(conformidade, meta, 94.73, 100, 103.15);
    }

    static getTableRelApontamentos(paramsCliente, IndicadorClass) {
        return [
            { title: "Data", width: 'auto', getValue: (a) => a.dataRef.split("-").reverse().join('/') },
            { title: "Laudo", field: "laudoRef.sequencialIndex", width: 28 },
            { title: "Cod.", field: "laudoRef.fazenda.codFazenda", width: 'auto' },
            { title: "Fazenda", field: "laudoRef.fazenda.nomeFazenda" },

            { title: "Talhão", field: "talhao.nome" },

            { title: "Frota", field: "trator.numeroFrotaTrator", width: 'auto' },
            { title: "Frente", field: "frente", width: 'auto' },
            {
                title: "Operador", width: 'auto', getValue: (a) => {
                    if (a.operador && a.operador.operador) return a.operador.operador
                    if (typeof a.operador === "string" && a.operador) return a.operador
                    return "-"
                }
            },
            { title: "Implemento", field: "implemento.nomeImplemento", width: 'auto' },

            { title: "Dose Recomendada", width: 'auto', getValue: (a) => parseFloat(a.dosagemRecomendada).toFixed(2) },
            { title: "Dose Real", width: 'auto', getValue: (a) => parseFloat(a.media).toFixed(2) },

            {
                title: "Conf.(%)", field: "conformidade", width: 38, getColor: a => {
                    return IndicadorClass.getColorStatus(IndicadorClass.getConformidadeStatus(a.conformidade, paramsCliente?.meta))
                }
            },
        ]
    }

    static getResultStr(apontamento) {
        let dosagemRecomendada = parseFloat(apontamento.dosagemRecomendada).toFixed(2)
        let media = parseFloat(apontamento.media).toFixed(2)

        return "Dose Recomendada: " + dosagemRecomendada +
            " e Dose Real: " + media
    }
}
